import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65329516")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["toggle", {'disable': _ctx.isDisabled }]
  }, [
    _createVNode("input", {
      class: ["toggle-button", _ctx.size],
      type: "checkbox",
      id: _ctx.value,
      disabled: _ctx.isDisabled
    }, null, 10, ["id", "disabled"])
  ], 2))
})